<template>
  <div class="doughnut-chart-container">
    <Doughnut :data="chartData" :options="chartOptions" :plugins="plugins" />
    <div class="below-text text-md">
      {{ sub }} out of {{ total }} members have replied
    </div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  name: 'DoughnutChart',
  components: { Doughnut },
  props: {
    total: {
      type: Number,
      default: 0
    },
    sub: {
      type: Number,
      default: 0
    }
  },
  computed: {
    percentage () {
      return this.total > 0 ? (this.sub / this.total) * 100 : 0
    },
    backgroundColor () {
      console.log(this.percentage)
      const p = this.percentage
      if (p === 0) return ['#FFD5CA', '#FFD5CA']
      if (p === 100) return ['#007D8F', '#007D8F']
      return ['#FEDD75', '#FFF7DD']
    },
    chartData () {
      const remaining = 100 - this.percentage
      // If at 100%, show only one segment (no gap)
      if (this.percentage >= 100) {
        return {
          labels: [],
          datasets: [{
            backgroundColor: ['#007D8F'],
            data: [100],
            borderWidth: 0,
            borderColor: 'transparent',
            spacing: 0
          }]
        }
      }
      return {
        labels: [],
        datasets: [{
          backgroundColor: this.backgroundColor,
          data: [Math.min(this.percentage, 100), remaining],
          borderWidth: 0,
          borderColor: 'transparent',
          spacing: 0
        }]
      }
    },
    chartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutout: 52,
        circumference: 360,
        rotation: 0,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false }
        }
      }
    },
    plugins () {
      const vm = this
      return [{
        id: 'centerText',
        beforeDraw (chart) {
          const { ctx, width, height } = chart
          ctx.restore()
          ctx.font = '24px Rubik'
          ctx.textBaseline = 'middle'
          const text = `${vm.percentage.toFixed(0)}%`
          const textX = Math.round((width - ctx.measureText(text).width) / 2)
          const textY = height / 2
          ctx.fillText(text, textX, textY)
          ctx.save()
        }
      }]
    }
  }
}
</script>

<style scoped>
.doughnut-chart-container {
  position: relative;
  text-align: center;
  margin-bottom: 30px;
  width: 176px;
  height: 176px;
  margin-left: auto;
  margin-right: auto;
}
.below-text {
  margin-top: 30px;
  white-space: nowrap;
  width: 200px;
  margin-left: -12px;
}
</style>
